export default {
	regionSelecionada: state => state.regionSelecionada,
	message: state => state.message,
	hasNewPlace: state => state.hasNewPlace,
	placeSelected: state => state.placeSelected,
	placesUser: state => state.placesUser,
	places: state => state.places,
	placesFiltered: state => {
		let lugaresFiltrados = state.places;
		if (state.regionSelecionada)
			lugaresFiltrados = state.places.filter(place => {
				return place.region == state.regionSelecionada;
			});
		lugaresFiltrados.sort((a, b) => {
			const nameA = a.name.toUpperCase(), // ignore upper and lowercase
				nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) return -1; //nameA comes first
			if (nameA > nameB) return 1; // nameB comes first
			return 0; // names must be equal
		});
		return lugaresFiltrados;
	},
	loading: state => state.loading,

	//notificationConfigurations: state => state.notificationConfigurations,
	notificationConfigurations: state => {
		return state.notificationConfigurations.reverse();
	},
	selectedNotificationConfig: state => state.selectedNotificationConfig,
};
